import { Accordion } from "../__shortcodes/accordions";
import mirrorHover from "../__utils/mirrorHover";
import Video from "../__utils/video";
import smoothScroll from "../__utils/smoothScroll";
import Tables from "../__utils/tables";
import forms from "../__utils/forms";
import vhUnit from "../__utils/vhUnit";
import AlertBar from "../__header/AlertBar";
import Locale from "../__utils/locale";
import { detect } from "detect-browser";
import HeaderMobile, {
    changeBackground as headerScrollBackground,
    closeMenu as closeHeader,
} from "../__header/MobileHeader";
import SearchBar, {
    closeSearch,
    hideSearchOutsideClick,
} from "../__header/SearchBar";
import DropdownNav, {
    closeDropdown as closeHeaderDropdown,
    hideDropdownOutsideClick,
} from "../__header/DropdownNav";
import { TourHeroSlider } from "../__utils/sliders";
import "../__utils/readMore";
import dropdownHeroInitial, { closeHeroDropdown } from "../__page/dropdownHero";
import pageNav from "../__page/inPageNav";
import mobileFixedButton from "../__page/mobileFixedBtn";

const browser = detect();
let lastXsize = window.innerWidth;

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector("html").classList.remove("no-js");
        document.querySelector("body").classList.add(browser.name);
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        Tables.init();
        Locale.init();
        vhUnit();
        AlertBar();
        HeaderMobile();
        SearchBar();
        DropdownNav();
        headerScrollBackground();
        TourHeroSlider.init();
        dropdownHeroInitial();
        pageNav.init();
        mobileFixedButton();
    },
    loaded() {
        document.querySelector("body").classList.add("page-has-loaded");
        vhUnit();
        pageNav.stickyPosition();
    },
    resized() {
        Tables.toggleShadow();
        vhUnit();
        pageNav.init();
        pageNav.stickyPosition();
        mobileFixedButton();

        //Watch resize only in X size
        if (lastXsize !== window.innerWidth) {
            lastXsize = window.innerWidth;
            closeHeader();
            closeSearch();
            closeHeaderDropdown();
        }
    },
    scrolled(e) {
        headerScrollBackground();
    },
    keyDown(e) {},
    mouseUp(e) {
        hideSearchOutsideClick(e);
        hideDropdownOutsideClick(e);
        closeHeroDropdown(e);
    },
    gformRender() {
        forms();
    },
};
export default controller;
